import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "\n      text-center text-gray-lp-300\n      xxl:text-16px\n      px-10\n      mb-5\n    " }
const _hoisted_2 = { class: "font-bold text-red-lp-100" }
const _hoisted_3 = /*#__PURE__*/_createVNode("p", { class: "mt-4" }, "Silahkan hubungi admin untuk mengaktifkan kembali", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("p", _hoisted_2, " Link Anda berlaku sampai " + _toDisplayString(_ctx.expiredDate), 1),
    _hoisted_3
  ]))
}